import * as yup from "yup";
import React from "react";
import { Nationalities } from "../../../utilities/constants";

export const formSteps = [
  {
    stepNo: 1,
    fullWidth: true,
    fields: [
      {
        name: "email",
        fieldId: "email",
        label: "Email address",
        type: "input-text",
        isRequired: true,
        size: 12,
      },
      {
        name: "firstName",
        fieldId: "firstName",
        label: "First name",
        type: "input-text",
        isRequired: true,
        size: 12,
        halfWidth: true,
      },
      {
        name: "lastName",
        fieldId: "lastName",
        label: "Last name",
        type: "input-text",
        floatRight: true,
        isRequired: true,
        size: 12,
        halfWidth: true,
      },
      {
        name: "phone",
        fieldId: "phone",
        label: "Phone",
        placeholder: "+38975123456",
        type: "input-text",
        isRequired: true,
        size: 12,
        halfWidth: true,
      },
      {
        name: "nationality",
        fieldId: "nationality",
        label: "Citizenship",
        type: "select",
        values: Nationalities.map((i) => ({ label: i, value: i })),
        floatRight: true,
        isRequired: true,
        size: 12,
        // multiple: true,
        halfWidth: true,
      },
      // {
      //   name: "dateOfBirth",
      //   fieldId: "dob",
      //   placeholder: "dd/mm/yyyy",
      //   label: "Date of birth",
      //   type: "input-date",
      //   floatRight: true,
      //   isRequired: true,
      //   size: 12,
      //   halfWidth: true,
      // },
      // {
      //   name: "password",
      //   fieldId: "password",
      //   label: "Password",
      //   type: "input-password",
      //   size: "12",
      //   halfWidth: true,
      // },
      // {
      //   name: "confirmPassword",
      //   fieldId: "confirmPassword",
      //   label: "Confirm passwod",
      //   type: "input-password",
      //   size: "12",
      //   halfWidth: true,
      // },
      {
        name: "tos",
        fieldId: "tos",
        label: React.createElement(
          "span",
          null,
          "I have read and understood the ",
          React.createElement(
            "a",
            {
              href: "https://posrednik24.com/en/privacy-policy/",
              target: "_blank",
              style: {
                color: "rgb(83, 114, 166)",
                textDecoration: "underline",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                lineHeight: "1.6",
                letterSpacing: "0.0075em",
              },
            },
            "Privacy Policy",
          ),
          " and ",
          React.createElement(
            "a",
            {
              href: "https://posrednik24.com/terms-and-conditions/",
              target: "_blank",
              style: {
                color: "rgb(83, 114, 166)",
                textDecoration: "underline",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                lineHeight: "1.6",
                letterSpacing: "0.0075em",
              },
            },
            "Terms & Conditions",
          ),
          ".",
        ),
        isRequired: true,
        type: "checkbox",
        size: 12,
      },
    ],
  },
];

export const registerSchema = yup
  .object()
  .shape({
    email: yup.string("The email is not valid.").email("Please enter a valid email.").required("Please enter your email."),
    firstName: yup.string("The first name field is not valid.").required("The first name field is required."),
    lastName: yup.string("The last name field is not valid.").required("The last name field is required."),
    // dateOfBirth: yup
    //   .string()
    //   .required("The date of birth is required.")
    //   .test("dob-validation", "The date of birth must be in the past.", (val) => dayjs(val).isBefore(dayjs())),
    phone: yup.string("The phone is not valid.").trim().required("Please enter your phone.").matches(/^\+/, "Phone number must include country code (e.g., +389 for Macedonia)"),
    // nationality: yup.array().min(1, "Please select at least one nationality").required("The nationality field is required."),
    nationality: yup.string("The citizenship field is not valid.").required("The citizenship field is required."),
    // password: yup
    //   .string("The password is not valid.")
    //   .required("Please enter your password.")
    //   .min(8, "The password must be at least 8 characters long.")
    //   .matches(/[a-z]+/, "The password must contain at least one lowercase character.")
    //   .matches(/[A-Z]+/, "The password must contain at least one uppercase character.")
    //   .matches(/\d+/, "The password must contain at least one number."),
    // confirmPassword: yup
    //   .string("The password is not valid.")
    //   .required("Please confirm your password.")
    //   .oneOf([yup.ref("password"), null], "Passwords do not match."),
    tos: yup
      .bool("The TOS is not valid.")
      .required("Please accept our Privacy Policy and Terms & Conditions.")
      .test("tos-accept", "You must accept our Privacy Policy and Terms & Conditions to continue.", (val) => val === true),
  })
  .required();

export const companyFormSteps = [
  {
    stepNo: 1,
    fullWidth: true,
    fields: [
      {
        name: "email",
        fieldId: "email",
        label: "Email address",
        type: "input-text",
        isRequired: true,
        size: 12,
      },
      {
        name: "name",
        fieldId: "name",
        label: "Company Name",
        type: "input-text",
        isRequired: true,
        size: 12,
        halfWidth: true,
      },
      {
        name: "phone",
        fieldId: "phone",
        label: "Phone",
        placeholder: "+38975123456",
        type: "input-text",
        isRequired: true,
        size: 12,
        halfWidth: true,
      },
      {
        name: "password",
        fieldId: "password",
        label: "Password",
        type: "input-password",
        size: "12",
        halfWidth: true,
      },
      {
        name: "confirmPassword",
        fieldId: "confirmPassword",
        label: "Confirm passwod",
        type: "input-password",
        size: "12",
        halfWidth: true,
      },
      {
        name: "tos",
        fieldId: "tos",
        label: React.createElement(
          "span",
          null,
          "I have read and understood the ",
          React.createElement(
            "a",
            {
              href: "https://posrednik24.com/en/privacy-policy/",
              target: "_blank",
              style: {
                color: "rgb(83, 114, 166)",
                textDecoration: "underline",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                lineHeight: "1.6",
                letterSpacing: "0.0075em",
              },
            },
            "Privacy Policy",
          ),
          " and ",
          React.createElement(
            "a",
            {
              href: "https://posrednik24.com/terms-and-conditions/",
              target: "_blank",
              style: {
                color: "rgb(83, 114, 166)",
                textDecoration: "underline",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                lineHeight: "1.6",
                letterSpacing: "0.0075em",
              },
            },
            "Terms & Conditions",
          ),
          ".",
        ),
        isRequired: true,
        type: "checkbox",
        size: 12,
      },
    ],
  },
];

export const companyRegisterSchema = yup
  .object()
  .shape({
    email: yup.string("The email is not valid.").email("Please enter a valid email.").required("Please enter your email."),
    name: yup.string("The name is not valid.").trim().required("The name is required."),
    phone: yup.string("The phone is not valid.").trim().required("Please enter your phone.").matches(/^\+/, "Phone number must include country code (e.g., +389 for Macedonia)"),
    password: yup
      .string("The password is not valid.")
      .required("Please enter your password.")
      .min(8, "The password must be at least 8 characters long.")
      .matches(/[a-z]+/, "The password must contain at least one lowercase character.")
      .matches(/[A-Z]+/, "The password must contain at least one uppercase character.")
      .matches(/\d+/, "The password must contain at least one number."),
    confirmPassword: yup
      .string("The password is not valid.")
      .required("Please confirm your password.")
      .oneOf([yup.ref("password"), null], "Passwords do not match."),
    tos: yup
      .bool("The TOS is not valid.")
      .required("Please accept our Privacy Policy and Terms & Conditions.")
      .test("tos-accept", "You must accept our Privacy Policy and Terms & Conditions to continue.", (val) => val === true),
  })
  .required();
